import axios from 'axios';
import {
  API_GET_FORECAST, API_GET_LAST_FORECAST_PRESET_BY_PARAMS, API_GET_LAST_FORECAST_PRESET, API_FORECAST_LAST_BY_POINT_USER,
  API_FORECAST_LAST_TIME,
  API_FORECAST_LAST_TIME_USER,
  API_FORECAST_DOMAIN_PREDICTS,
  API_FORECAST_DOMAINS_PREDICTS,
  API_FORECAST_POINTS_REPORT,
  API_FORECAST_POINT_REPORT
} from '../../constants'
import { download } from '../../utils/common';

export default {
  state: {
    forecast: [],
    forecastPreset: [],
    domainsPredicts: []
  },
  mutations: {
    SET_FORECAST: (state, payload) => {
      state.forecast = payload;
    },
    SET_FORECAST_PRESET: (state, payload) => {
      state.forecastPreset = payload;
    },
    SET_FORECAST_LAST_TIME: (state, payload) => {
      state.forecast = payload;
    },
    SET_DOMAINS_PREDICTS: (state, payload) => {
      state.domainsPredicts = payload;
    },
  },
  actions: {
    FETCH_FORECAST: async (context, payload) => {
      const url = `${API_GET_FORECAST}/${payload.userId}/point?from=${payload.dateStart}&to=${payload.dateEnd}&lat=${payload.latitude}&lon=${payload.longitude}`;
      let forecastResponse = await axios.get(url);
      const forecast = forecastResponse.data.result.data;
      let id = 1;
      forecast.forEach(r => {
        r.id = id++;
        let pId = 1;
        r.parameters.forEach(p => {
          p['id'] = pId++
        });
      });
      context.commit('PUSH_SUCCESS', 'Данные успешно получены');
      context.commit('SET_FORECAST', forecast);
    },
    FETCH_DOMAIN_PREDICTS: async (context, payload) => {
      try {
        const url = `${API_FORECAST_DOMAIN_PREDICTS(payload.domainName)}`;
        const response = await axios.get(url);
        const predicts = response.data.result.predicts;
        return predicts;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return []
      }
    },
    FETCH_DOMAINS_PREDICTS: async (context) => {
      try {
        const url = `${API_FORECAST_DOMAINS_PREDICTS(1000, 0)}`;
        const response = await axios.get(url);
        const result = response.data.result.data;
        context.commit('SET_DOMAINS_PREDICTS', result);
        return result;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return []
      }
    },
    FETCH_POINTS: async (context, payload) => {
      const url = `${API_GET_FORECAST}/domain/${payload.domain}/points`;
      let forecastResponse = await axios.post(url, payload.wapiPolygon2D);
      const response = forecastResponse.data.result.data;
      return response;
    },
    FETCH_LAST_FORECAST_PRESET_BY_PARAMS: async (context, payload) => {
      try {
        const url = `${API_GET_LAST_FORECAST_PRESET_BY_PARAMS}`;
        let forecastResponse = await axios.post(url, payload);
        const forecast = forecastResponse.data.result.data;
        let id = 1;
        forecast.forEach(r => {
          r.id = id++;
          let pId = 1;
          r.parameters.forEach(p => {
            p['id'] = pId++
          });
        });

        context.commit('SET_FORECAST_PRESET', forecast);
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FETCH_FORECAST_PRESET: async (context, payload) => {
      try {
        const url = `${API_GET_LAST_FORECAST_PRESET}/${payload.user_id}/preset/${payload.preset_id}`;
        let forecastResponse = await axios.get(url);
        const forecast = forecastResponse.data.result;
        context.commit('PUSH_SUCCESS', 'Данные успешно получены');
        context.commit('SET_FORECAST_PRESET', forecast);
        return forecast;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FETCH_FORECAST_LAST_BY_POINT_USER: async (context, payload) => {
      try {
        const url = API_FORECAST_LAST_BY_POINT_USER(payload.userId, payload.latitude, payload.longitude);
        let forecastResponse = await axios.get(url);
        const forecast = forecastResponse.data.result;

        context.commit('SET_FORECAST_PRESET', forecast);
        return forecast;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return null;
      }
    },
    FORECAST_REPORT: async (context, payload) => {
      try {
        const url = API_FORECAST_POINT_REPORT(payload.userId, payload.lat, payload.lon);
        const response = await axios.get(url, { responseType: "blob", baseURL: '' });
        download(response);
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FORECAST_POINTS_REPORT: async (context, payload) => {
      try {
        const url = `${API_FORECAST_POINTS_REPORT()}`;
        const response = await axios.post(url, payload, { responseType: "blob", baseURL: '' });
        download(response);
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FETCH_FORECAST_LAST_TIME: async (context) => {
      try {
        const url = `${API_FORECAST_LAST_TIME}`;
        let response = await axios.get(url);
        const result = response.data.result;

        context.commit('SET_FORECAST_LAST_TIME', result);
        return result;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FETCH_FORECAST_LAST_TIME_USER: async (context, payload) => {
      try {
        const url = `${API_FORECAST_LAST_TIME_USER(payload.userId)}`;
        let response = await axios.get(url);
        const result = response.data.result;

        context.commit('SET_FORECAST_LAST_TIME', result);
        return result;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
  },
  getters: {
    FORECAST: state => {
      return state.forecast;
    },
    FORECAST_PRESET: state => {
      return state.forecastPreset;
    },
    FORECAST_LAST_TIME: state => {
      return state.lastTime;
    },
    DOMAINS_PREDICTS: state => {
      return state.domainsPredicts;
    },
  }
}